
import MainLayout from "../layout/MainLayout";
import SewaArrears from "../components/arreasCollection/Sewa/SewaArrears";
import AirArrears from "../components/arreasCollection/Air/AirArrears";
import { useAuth } from "../Auths/CheckUser";


const RentArrearsReport = () => {

    const {user} = useAuth();
  

  return (
    <MainLayout>
    <div className="p-5">
   
         {user.type === "sewa" && <SewaArrears/>}
         {user.type === "air" && <AirArrears/>}

    </div>
    </MainLayout>
  );
}
export default RentArrearsReport